
























import * as Util from '@/util.ts';
import * as Constants from '@/constants.ts';
import Vue from 'vue';

export default Vue.extend({
  computed: {
    menusToPickFrom(): Menu[] {
      return this.$store.state.menusToPickFrom;
    },
  },
  methods: {
    setMenu(menu: Menu) {
      this.$store.commit('setCurrentMenu', menu);
      Util.routerPush({ path: Constants.allRoutes.menu });
    },
  },
});
